import { Link as RouterLink } from 'react-router-dom';
import { Box, BoxProps } from '@mui/material';
import { APP_CONFIG } from 'configs/app.config';

interface Props extends BoxProps {
  disabledLink?: boolean;
}

export default function Logo({ disabledLink = false, sx }: Props) {
  const logo = <Box sx={{ width: 40, height: 40, ...sx }}>{APP_CONFIG.LOGO}</Box>;

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
